// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__NStm3","amount":"Amount_amount__1baty","tip":"Amount_tip__3XMRn","tipHeader":"Amount_tipHeader__1k1oY","tipsWrap":"Amount_tipsWrap__1mFKr"};